import { render, staticRenderFns } from "./DisplayTodos.vue?vue&type=template&id=33aee842&scoped=true&"
import script from "./DisplayTodos.vue?vue&type=script&lang=js&"
export * from "./DisplayTodos.vue?vue&type=script&lang=js&"
import style0 from "./DisplayTodos.vue?vue&type=style&index=0&id=33aee842&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aee842",
  null
  
)

export default component.exports